export const MODAL_WIDTH = "940px";
export const MODAL_MAX_WIDTH = "90vw";
